import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import {
  RangeAnswer,
  RangeGroup,
  RangeLabel,
  RangeInputRadio,
  ContainerRange,
} from './styles';

const Range = (props) => (
  <RangeAnswer>
    <ContainerRange>
      {_.range(1, props.options + 1).map((index) => (
        <RangeGroup key={props.parentKey + index}>
          <RangeInputRadio type="radio" name={props.questionId} id={props.questionId + index} disabled checked={index === props.checked} />
          <RangeLabel htmlFor={props.questionId + index}>{index}</RangeLabel>
        </RangeGroup>
      ))}
    </ContainerRange>
  </RangeAnswer>
);

Range.propTypes = {
  questionId: PropTypes.string,
  checked: PropTypes.number.isRequired,
  options: PropTypes.number.isRequired,
  parentKey: PropTypes.number.isRequired,
};

Range.defaultProps = {
  questionId: '',
};

export default Range;
